import React, { useState } from "react";
import { LoginResponseType } from "../../../../redux/auth/authTypes";
import Select from "react-select";
import { SelctOptionType } from "../../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import { PaperClipIcon } from "../../../Icon";
// import { UploadFileTypesPayload } from "../../../../commonTypes/fileManagerTypes";
import MultipleUpload from "../../../commons/Upload/MultipleUpload";

type AppProps = {
  scopeOfWork: SelctOptionType[];
  handleScopeOfWorkChange: (data: any) => void;
  finalScopeOfWorkList: any;
  setScopeOfWorkText: React.Dispatch<React.SetStateAction<string>>;
  setScopeOfWorkOffset: React.Dispatch<React.SetStateAction<number>>;
  scopeOfWorkLimit: number;
  fetching: boolean;
  loginData: LoginResponseType;
  modal:boolean;
  showUploadModal:()=>void;
  containerName:string | undefined;
  uploadSuccessArray:any;
  setUploadSuccessArray:any;
  // handleUploadFile:(data:UploadFileTypesPayload )=>void;
  uploadData:any;
  setShowImagePreview:React.Dispatch<React.SetStateAction<boolean>>;
  
};
const ScopeOfWorkDetails = ({
  scopeOfWork,
  handleScopeOfWorkChange,
  finalScopeOfWorkList,
  setScopeOfWorkText,
  setScopeOfWorkOffset,
  scopeOfWorkLimit,
  fetching,
  loginData,
  modal,
  showUploadModal,
  containerName,
  uploadSuccessArray,
  setUploadSuccessArray,
  // handleUploadFile,
  uploadData,
  setShowImagePreview,
}: AppProps) => {
  const [accessToOthersText, setAccessToOthersText] = useState<string>("");
  const checkBottom = (e: any) => {
    setScopeOfWorkOffset((prv: any) => prv + scopeOfWorkLimit);
  };
  return (
    <>
      <p style={{ marginTop: "12px", fontWeight: "500" }}>
        SCOPE OF WORK DETAILS
      </p>
      <div className="row">
        <div className="col-md-3">
          <label>Scope of Work</label>
          <Select
            className="dropdown"
            placeholder={
              <div style={{ color: "hsl(0, 0%, 20%)" }}>Select..</div>
            }
            value={
              scopeOfWork[0]?.label
                ? scopeOfWork?.filter(
                    (e: any) => e?.value !== loginData?.user_id
                  )
                : []
            }
            options={finalScopeOfWorkList}
            onChange={handleScopeOfWorkChange}
            isMulti
            isClearable
            isLoading={fetching && accessToOthersText?.length > 0}
            isSearchable={true}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            onInputChange={(e: string) => {
              setScopeOfWorkText(e);
              setAccessToOthersText(e);
              setScopeOfWorkOffset(0);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ScopeOfWorkDetails;
